module.exports = __webpack_public_path__ + "static/media/bg-blockquote.1b073655.svg";